import { render, staticRenderFns } from "./sale-view-tabs-goods.vue?vue&type=template&id=083fa64c&"
import script from "./sale-view-tabs-goods.ts?vue&type=script&lang=ts&"
export * from "./sale-view-tabs-goods.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports